import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/homeMain',
    component: () => import('@/views/home/Home'),
    children: [
      {
        path: 'homeMain',
        name: 'homeMain',
        component: () => import('@/views/HomeMain')
      },
      {
        path: 'search',
        name: 'search',
        component: () => import('@/views/search/Search'),
        meta: {title: '搜索', activeMenu: 'homeMain'}
      },
      {
        path: 'dealCenter',
        name: 'dealCenter',
        component: () => import('@/views/dealInformation/DealCenter')
      },
      {
        path: 'down',
        name: 'down',
        component: () => import('@/views/download/Down')
      },
      {
        path: 'operateMain',
        name: 'operateMain',
        component: () => import('@/views/operate/OperateMain')
      },
      {
        path: 'dealDetails',
        name: 'dealDetails',
        component: () => import('@/views/dealInformation/DealDetails')
      },
      {
        path: 'noticeDetails/:id',
        name: 'noticeDetails',
        component: () => import('@/views/home/noticeDetails')
      },
      {
        path: 'dealMore',
        name: 'dealMore',
        component: () => import('@/views/dealInformation/DealMore')
      },
      {
        path: 'policyMore',
        name: 'policyMore',
        component: () => import('@/views/dealInformation/PolicyMore')
      },
      {
        path: 'policyDetails',
        name: 'policyDetails',
        component: () => import('@/views/dealInformation/PolicyDetails')
      },
      {
        path: 'lxwm',
        name: 'contactUs',
        component: () => import('@/views/contact/contactUs')
      }
    ]
  },
  {
    path: '/collectSignInfo',
    name: 'CollectSignInfo',
    component: () => import('@/views/sign/CollectSignInfo'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/collectSignImg',
    name: 'CollectSignImg',
    component: () => import('@/views/sign/CollectSignImg')
  }
]
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js